import React, { useRef, useState } from 'react'
import { FaEdit, FaEye, FaRegEdit, FaTrash } from 'react-icons/fa'
import { useDispatch } from 'react-redux';
import { displayLargeImage, displayRemoveAlert, updateFormInfo } from '../../redux/slice/formUpdateSlice';
import { consoleLog } from '../../utils/log-utils';
import { getImagePath } from '../../utils/util';
import noImage from "../../assets/no_image.jpg";
import { podcastImageUplaodRequest, radioImageUplaodRequest } from '../../network/service/ImageUploadService';


function PoadcastItem(props) {
  const dispatch=useDispatch();
  const [poadcast]=useState(props.result)
  const hiddenFileInput = useRef(null);
  const [file, setFile] = useState();
  consoleLog("poadcast item",poadcast)

  const deleteItem = () => {
    consoleLog("item",poadcast)
    dispatch(displayRemoveAlert({ displayRemove: true, formData: { item: poadcast.info},type:"poadcast" }));
  };

  const onNgImageClick = () => {
    hiddenFileInput.current.click();
  };
  const showLargeImage = () => {
      dispatch(
        displayLargeImage({ displayLargeImage: true, formData: { item: poadcast } })
      );
    };

    const handleImageInputChange = (event) => {
      const fileUploaded = event.target.files[0];
      if (fileUploaded != null) {
        setFile(URL.createObjectURL(fileUploaded));
        uploadImage(fileUploaded);
      }
    };

    const uploadImage = async (file) => {
        const form_data = new FormData();
        form_data.append("file", file);
        let requestBody = {
          id: poadcast.info.id,
          fileData: form_data,
        };
        consoleLog("imagereq",requestBody)
        await dispatch(podcastImageUplaodRequest(requestBody)).then(
          (response) => { }
        );
      };

  const editItem = () => {
   
    dispatch(updateFormInfo({ displayForm: true, formData: { item: poadcast } }));
    
  };
  
  return (
    <>
    {
      consoleLog("option key",props.result.option_key)
    }
      
      <tr>
        <td>{props.id}</td>
        <td>{poadcast.info.languageName}</td>
        <td>{poadcast.info.name}</td>

        <td className="align-middle">
          <div className="cat_mainwrap" onClick={onNgImageClick}>
            {
           poadcast.info.image_path=== ""? null : (
              <div className="cat_mainwrap">
             {
            poadcast.info.image_path === null ? null :
              
               <div className="cat_btnwrap">
              <FaRegEdit className="faWhite" onClick={() => onNgImageClick()} />
              
              <FaEye className="faWhite" onClick={() => showLargeImage()} />
            </div>
             
          }

              <input
                type="file"
                onChange={handleImageInputChange}
                ref={hiddenFileInput}
                style={{ display: "none" }} // Make the file input element invisible
              />
              {file ? (
                <>
                  <img
                    src={file}
                    alt={poadcast.info.name}
                    className="img-thumbnail"
                    width="50px"
                    height="50px"
                  />
                </>
              ) : poadcast.info.image_path !== null ? (
                <img
                  src={getImagePath(poadcast.info.image_path)}
                  alt={poadcast.info.name}
                  className="img-thumbnail"
                  width="50px"
                  height="50px"
                />
              ) : (
                <img
                  src={noImage}
                  // alt={poadcast.info.name}
                  className="img-thumbnail"
                  width="50px"
                  height="50px"
                />
              )}
            </div>
            )}

           
          </div>
        </td> 

        <td>{poadcast.info.poadcast_url}</td>
        <td>{poadcast.tags&&poadcast.tags.map(i=>i.name+", ")}</td>


        {/* <td>
          <div class="form-check form-switch col-lg-12 d-flex justify-content-center">

            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              checked={props.result.status === "ACTIVE" ? true : false}

            />

          </div>

        </td> */}
       <td className="align-middle">
          <div className="d-flex justify-content-center">
            <span className="edit-icon-btn" onClick={editItem}>
              <FaEdit />
            </span>
            <span className="delete-icon-btn">
              <FaTrash onClick={deleteItem}/>
            </span>
          </div>
        </td>
       

      </tr>
    </>

  )
}

export default PoadcastItem